<script>
import { HomepageSiteSettings } from '@/api/'
import SettingsForm from '@/views/Settings/SettingsForm'
import pageHeaderFields from '@/common/js/pageHeaderFields'
import fields from '@/components/fields/'

export default {
  extends: SettingsForm,
  methods: {
    getFields() {
      return [
        ...pageHeaderFields(this),
        new fields.Input({
          label: 'Tytuł dla facebooka',
          modelPath: [this, 'form', 'og_title']
        }),
        new fields.Input({
          label: 'Opis dla facebooka',
          modelPath: [this, 'form', 'og_description'],
          type: 'textarea'
        }),
        new fields.Image({
          label: 'Zdjęcie dla facebooka',
          modelPath: [this, 'form', 'og_image']
        }),
        new fields.Input({
          label: 'Tytuł strony dla wyszukiwarki google',
          modelPath: [this, 'form', 'meta_title']
        }),
        new fields.Input({
          label: 'Opis dla wyszukiwarki google',
          modelPath: [this, 'form', 'meta_description'],
          type: 'textarea'
        })
      ]
    }
  },
  computed: {
    service() {
      return HomepageSiteSettings
    }
  }
}
</script>
